exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Options_options-list_2Tdy {\n  margin: 10px 0 0;\n  padding: 0;\n\n  list-style: none;\n}\n\n  .Options_options-list__item_afUM {\n    margin-bottom: 10px;\n\n    display: -webkit-box;\n\n    display: -webkit-flex;\n\n    display: -ms-flexbox;\n\n    display: flex\n  }\n\n  .Options_options-list__item_afUM:last-of-type {\n  margin-bottom: 0;\n}\n\n  .Options_options-list__item-label_5VtJ {\n      margin-right: 6px;\n}\n", ""]);

// exports
exports.locals = {
	"options-list": "Options_options-list_2Tdy",
	"options-list__item": "Options_options-list__item_afUM",
	"options-list__item-label": "Options_options-list__item-label_5VtJ"
};